import { useState } from 'react'
import { ToolTip } from '../../../../components/toolTip/ToolTip'
import { translations } from '../../../../configs/translations'
import { useStore } from '../../../../store/store'
import { formatPriceUptoK } from '../../../../utils/formatPriceUptoK'
import './RatingAchievement.css'

export interface RatingAchievementProps {
	type: 'MATCHES' | 'WINS',
	amount: number
}

export const RatingAchievement = ({ type, amount }: RatingAchievementProps) => {
	const language = useStore(state => state.language) as keyof typeof translations;
	const t = translations[language];	

	const [mouseX, setMouseX] = useState<number>(0)
	const [mouseY, setMouseY] = useState<number>(0)
	const [isTooltipShown, setIsTooltipShown] = useState<boolean>(false)

	const getText = () => {
		const amountStr = amount.toString()
		const lastChar = amountStr.charAt(amountStr.length - 1)
		switch (type) {
			case 'MATCHES':
				if (lastChar === '1') return t.matches_played_1
				if (lastChar === '2' || lastChar === '3' || lastChar === '4') return t.matches_played_2
				return t.matches_played_5
			case 'WINS':
				if (lastChar === '1') return t.wins_1
				if (lastChar === '2' || lastChar === '3' || lastChar === '4') return t.wins_2
				return t.wins_5
		}
	}

	const getPicture = () => {
		switch (type) {
			case 'MATCHES': return '/icons/256px/car.svg'
			case 'WINS': return '/icons/256px/prize.svg'
		}
	}

	const handleMouseEnter = (e: React.MouseEvent) => {
		setMouseX(e.clientX)
		setMouseY(e.clientY)
		setIsTooltipShown(true)
	}

	const handleMouseLeave = () => {
		setIsTooltipShown(false)
	}

	const handleMouseMove = (e: React.MouseEvent) => {
		setMouseX(e.clientX)
		setMouseY(e.clientY)
	}

	return (
		<div className='rating-achievement'>
			<div className='rating-achievement-icon'>
				<img src={getPicture()} alt='car' />
			</div>
			<div className='rating-achievement-header'>
				<p
					onMouseEnter={handleMouseEnter} 
					onMouseLeave={handleMouseLeave}
					onMouseMove={handleMouseMove}
				>
					{formatPriceUptoK(amount)}
				</p>
			</div>
			<ToolTip 
				style='top'
				position={{
					x: mouseX,
					y: mouseY
				}} 
				content={amount} 
				isShown={isTooltipShown}				
			/>
			<div className='rating-achievement-body'>
				<p>{getText()}</p>
			</div>
		</div>
	)
}